var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c(
            "el-dialog",
            {
              staticClass: "articleModal",
              attrs: {
                visible: _vm.visible,
                title: _vm.pram.id ? "门店信息编辑" : "门店信息增加",
                top: "100px",
                width: "800px",
                "destroy-on-close": "",
                modal: false,
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.initLoading,
                      expression: "initLoading",
                    },
                  ],
                  ref: "pram",
                  attrs: { "label-width": "120px", model: _vm.pram },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "门店商家：",
                        prop: "supplierId",
                        rules: [
                          {
                            required: true,
                            message: "请选择门店商家",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleSupplierSearch,
                          },
                          model: {
                            value: _vm.pram.supplierId,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "supplierId", $$v)
                            },
                            expression: "pram.supplierId",
                          },
                        },
                        _vm._l(_vm.supplierLists, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.companyName, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Logo",
                        prop: "image",
                        rules: [
                          {
                            required: true,
                            message: "请上传门店LOGO",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("1", "image")
                                },
                              },
                            },
                            [
                              _vm.pram.image
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.pram.image },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.image
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "16px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("image")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "门店名称：",
                        prop: "name",
                        rules: [
                          {
                            required: true,
                            message: "请填写门店名称",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.pram.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "name", $$v)
                          },
                          expression: "pram.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "门店城市：",
                        prop: "cityId",
                        rules: [
                          {
                            required: true,
                            message: "请选择门店城市",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          options: _vm.addresData,
                          props: {
                            value: "id",
                            label: "name",
                            children: "child",
                            checkStrictly: true,
                          },
                        },
                        model: {
                          value: _vm.pram.cityId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "cityId", $$v)
                          },
                          expression: "pram.cityId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "门店详细地址：",
                        prop: "address",
                        rules: [
                          {
                            required: true,
                            message: "请填写门店详细地址",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.pram.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "address", $$v)
                          },
                          expression: "pram.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "经度：",
                        prop: "longitude",
                        rules: [
                          {
                            required: true,
                            message: "请填写经度",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          clearable: "",
                          placeholder: "请填写",
                        },
                        model: {
                          value: _vm.pram.longitude,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "longitude", $$v)
                          },
                          expression: "pram.longitude",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "纬度：",
                        prop: "latitude",
                        rules: [
                          {
                            required: true,
                            message: "请填写维度",
                            trigger: ["change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          clearable: "",
                          placeholder: "请填写",
                        },
                        model: {
                          value: _vm.pram.latitude,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "latitude", $$v)
                          },
                          expression: "pram.latitude",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "预约电话：", prop: "appointmentPhone" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.pram.appointmentPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "appointmentPhone", $$v)
                          },
                          expression: "pram.appointmentPhone",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v("多个电话之间以英文逗号分隔。")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handerSubmit("pram")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }